import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { ToastComponent } from './services/toast/components/toast/toast.component';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClientInterceptor } from './interceptors/http-client.interceptor';
import { MatCardModule } from '@angular/material/card';
import { InterviewersModule } from './main/components/interviewers/interviewers.module';
import { CommonModule } from '@angular/common';
import { ResumeComponent } from './main/components/interview/components/resume/resume.component';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';


@NgModule({
  declarations: [
    AppComponent,


  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    AuthModule,
    BrowserAnimationsModule,
    MatSnackBarModule,  // Add MatSnackBarModule to imports
    MatCardModule,  // Add MatCardModule to imports
    MatNativeDateModule,
    MatDialogModule,
    OverlayModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatSelectModule

  ],

  providers: [
    ToastComponent,
    MatSnackBar,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpClientInterceptor,
      multi: true
    },
  ],


  bootstrap: [AppComponent]
})
export class AppModule { }
